import { InjectionToken } from "@angular/core";

export interface AppConfiguration {
    svgVersion: string;
    appName: "maas" | "portal";
}

export const APP_CONFIGURATION = new InjectionToken<AppConfiguration>("APP_CONFIGURATION");
